import React from "react";

// Original line icons for the full-menu category strip (currentColor strokes).
const paths = {
  roll: '<path d="M14 46h32v10a10 10 0 0 1-10 10H24a10 10 0 0 1-10-10z"/><path d="M18 46c-2-14 8-22 16-22s16 8 12 22"/><path d="M30 46c-1-8 3-14 6-14"/><circle cx="24" cy="34" r="2"/>',
  plate: '<ellipse cx="30" cy="42" rx="24" ry="8"/><path d="M12 42c0 6 8 10 18 10s18-4 18-10"/><path d="M18 36c4-10 20-10 24 0"/><path d="M24 30c3-6 9-6 12 0"/>',
  sundae: '<path d="M16 30h28l-4 26H20z"/><path d="M14 30c0-8 8-14 16-14s16 6 16 14"/><path d="M24 22l4-8m4 8l0-10m4 10l4-8"/><circle cx="30" cy="9" r="3"/>',
  cone: '<path d="M18 26h24L30 56z"/><path d="M22 34h16M25 42h10"/><path d="M18 26a12 10 0 0 1 24 0"/><path d="M24 18a6 6 0 0 1 12 0"/>',
  shake: '<path d="M20 22h20l-3 32H23z"/><path d="M16 22h28"/><path d="M34 22l6-14"/><path d="M24 34h12"/>',
  momo: '<path d="M12 44h36c0 6-8 10-18 10S12 50 12 44z"/><path d="M14 42c2-12 10-20 16-20s14 8 16 20"/><path d="M22 30c2-4 6-6 8-6s6 2 8 6"/><path d="M18 36c3 1 7 1 12 0s9-1 12 0"/>',
  munchies: '<path d="M18 28h24l-3 28H21z"/><path d="M22 28l2-14m6 14l0-16m6 16l-2-14"/><path d="M20 40h20"/>',
  signature: '<path d="M30 8l5 11 12 2-9 8 2 12-10-6-10 6 2-12-9-8 12-2z"/><path d="M12 50h36"/><path d="M16 56h28"/>',
  burger: '<path d="M14 26a16 10 0 0 1 32 0z"/><path d="M12 32h36M14 38h32"/><path d="M14 44h32v4a6 6 0 0 1-6 6H20a6 6 0 0 1-6-6z"/>',
  sandwich: '<path d="M10 40l20-14 20 14z"/><path d="M12 40v6h36v-6"/><path d="M16 40c4 3 10 4 14 4s10-1 14-4"/>',
  bottle: '<path d="M24 8h12v8l4 6v30a4 4 0 0 1-4 4H24a4 4 0 0 1-4-4V22l4-6z"/><path d="M20 30h20M20 44h20"/>',
};

export default function CategoryIcon({ name, className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 60 64"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      dangerouslySetInnerHTML={{ __html: paths[name] || paths.plate }}
    />
  );
}
